import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { Logo as SiteLogo } from '../../components/Logo';
import { FontFiles } from '../../globals';
import { getMemoramaParticipants } from '../../services/memoramaApi';
import { MemoryGlobal, Shell, TopLine, Header, RecordsContent, RecordsHeader, RecordsTitle, RecordsSubtitle, TableWrapper, RecordsTable, StatusMessage, RefreshButton, RecordsActions } from '../MemoryGamePage/MemoryGamePage.styles';

const parseExtras = (extras) => {
  if (!extras) return {};
  if (typeof extras === 'object') return extras;
  try { return JSON.parse(extras); } catch { return {}; }
};

const normalizeRecords = (records) => records.map((record, index) => {
  const extras = parseExtras(record.extras);
  return {
    id: record.id || record._id || index,
    fullName: record.full_name || record.fullName || '-',
    email: record.email || '-',
    phone: record.phone || '-',
    company: record.company || '-',
    pairs: extras.aciertos ?? record.aciertos ?? '-',
    prize: extras.premio ?? record.premio ?? 'Sin premio',
  };
});

export default function MemoryGameRegisterPage() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadRecords = async () => {
    setLoading(true);
    setError('');
    try { setRecords(normalizeRecords(await getMemoramaParticipants())); }
    catch { setError('No se pudieron cargar los registros. Intenta nuevamente.'); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadRecords(); }, []);

  const downloadExcel = () => {
    const rows = records.map(record => ({
      Nombre: record.fullName,
      Email: record.email,
      Teléfono: record.phone,
      Empresa: record.company,
      Aciertos: record.pairs,
      Premio: record.prize,
    }));
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Participantes');
    XLSX.writeFile(workbook, 'memorama-participantes.xlsx');
  };

  return <Shell><FontFiles /><MemoryGlobal /><TopLine /><Header><SiteLogo /></Header><RecordsContent><RecordsHeader><div><RecordsTitle>Registros del memorama</RecordsTitle><RecordsSubtitle>Participantes y resultados de la dinámica.</RecordsSubtitle></div><RecordsActions><RefreshButton type="button" onClick={loadRecords}>Actualizar</RefreshButton><RefreshButton type="button" onClick={downloadExcel} disabled={!records.length}>Descargar Excel</RefreshButton></RecordsActions></RecordsHeader>{loading && <StatusMessage>Cargando registros...</StatusMessage>}{error && <StatusMessage error>{error}</StatusMessage>}{!loading && !error && <TableWrapper><RecordsTable><thead><tr><th>Nombre</th><th>Email</th><th>Teléfono</th><th>Empresa</th><th>Aciertos</th><th>Premio</th></tr></thead><tbody>{records.length ? records.map(record => <tr key={record.id}><td>{record.fullName}</td><td>{record.email}</td><td>{record.phone}</td><td>{record.company}</td><td>{record.pairs}</td><td>{record.prize}</td></tr>) : <tr><td colSpan="6">No hay registros todavía.</td></tr>}</tbody></RecordsTable></TableWrapper>}</RecordsContent></Shell>;
}
